import { render, staticRenderFns } from "./KpiAvatarStack.vue?vue&type=template&id=15a3790c&"
import script from "./KpiAvatarStack.vue?vue&type=script&lang=js&"
export * from "./KpiAvatarStack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports